import React from "react";

import useTheme from "../../hooks/useTheme";
import { ERPType } from "../../types/types";

export default function Ergo() {
  const theme = useTheme();

  return (
    <div>
      <img
        src={theme.images.ergo}
        style={{ height: 50, width: 100 }}
        alt={ERPType.ergo}
      />
    </div>
  );
}
